export const headTableCells = [
  { id: 1, property: '', label: '', width: '5%' },
  { id: 2, property: 'Title', label: 'Keyword', width: '60%' },
  { id: 3, property: 'Instructions', label: 'Instructions', width: '35%' },
];
